<template>
    <p class="text-center">
        &copy;2020
        <a href="#" @click="toHome()">bluedio.com</a> All right reserved
    </p>
</template>

<script>
export default {
    name: "FootShortSection",
    methods: {
        toHome() {
            this.$router.push({
                name: "enhome",
            });
        },
    }
};
</script>
